import axios from "axios";
import { getApiBase } from "@/lib/httpClient";

const api = () => `${getApiBase()}/finance`;
const config = { withCredentials: true };
const result = (response) => response.data;
const key = () => (globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `idempotency-${Date.now()}-${Math.random().toString(16).slice(2)}`);

export function parseBRL(value) {
  return Number(parseBRLExact(value));
}

export function parseBRLExact(value) {
  const raw = String(value ?? "").trim().replace(/\s/g, "").replace(/^R\$\s?/, "");
  // preco-fixo: exemplo de formato numa mensagem de erro, não é preço de plano
  if (!raw || !/^\d{1,3}(\.\d{3})*(,\d{1,2})?$|^\d+(,\d{1,2})?$/.test(raw)) throw new Error("Informe um valor em reais, por exemplo R$ 1.234,56.");
  const [integer, fraction = ""] = raw.replace(/\./g, "").split(",");
  if (integer.length > 12) throw new Error("O valor informado é maior que o limite permitido.");
  const cents = BigInt(integer) * 100n + BigInt((fraction + "00").slice(0, 2));
  if (cents <= 0n || cents > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("O valor deve ser maior que zero e estar dentro do limite permitido.");
  return cents;
}

export function formatBRL(cents) { return (Number(cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }); }
const mutation = (data) => axios({ method: "post", url: api(), data, ...config, headers: { "Idempotency-Key": key() } }).then(result);
const post = (path, data) => axios.post(`${api()}${path}`, data, { ...config, headers: { "Idempotency-Key": key() } }).then(result);

export const financeiroApi = {
  entries: (params = {}) => {
    const fields = ["direction", "state", "start_date", "end_date", "limit"];
    const canonical = Object.fromEntries(fields.filter((field) => params[field] !== "" && params[field] != null).map((field) => [field, params[field]]));
    return axios.get(`${api()}/entries`, { ...config, params: canonical }).then(result);
  },
  entry: (id) => axios.get(`${api()}/entries/${encodeURIComponent(id)}`, config).then(result),
  create: (data) => post("/entries", data),
  adjustments: (id, data) => post(`/entries/${encodeURIComponent(id)}/adjustments`, data),
  settlements: (entryId, installmentId, data) => post(`/entries/${encodeURIComponent(entryId)}/installments/${encodeURIComponent(installmentId)}/settlements`, data),
  settlementReversals: (entryId, installmentId, data) => post(`/entries/${encodeURIComponent(entryId)}/installments/${encodeURIComponent(installmentId)}/settlement-reversals`, data),
  reversal: (id, data) => post(`/entries/${encodeURIComponent(id)}/reversal`, data),
  summary: (params = {}) => axios.get(`${api()}/summary`, { ...config, params: Object.fromEntries(["start_date", "end_date"].filter((field) => params[field]).map((field) => [field, params[field]])) }).then(result),
  export: (body = {}) => axios.post(`${api()}/exports`, body, { ...config, responseType: "blob", headers: { "Idempotency-Key": key() } }),
  mutation,
};

// ─── Asaas ────────────────────────────────────────────────────────────────
const asaasBase = () => `${getApiBase()}/asaas`;

export const asaasApi = {
  status: () => axios.get(`${asaasBase()}/status`, config).then(result),
  billingDefaults: () => axios.get(`${asaasBase()}/billing-defaults`, config).then(result),
  charges: (entry_id) => axios.get(`${asaasBase()}/charges`, { ...config, params: { entry_id } }).then(result),
  createCharges: (payload) => axios.post(`${asaasBase()}/charges`, payload, config).then(result),
  webhookConfig: () => axios.get(`${asaasBase()}/webhook-config`, config).then(result),
  generateWebhookToken: () => axios.post(`${asaasBase()}/webhook-config`, {}, config).then(result),
};
